export default class WidgetValidator {
  name = 'url'
  message = 'Только url'
  constructor (name, message) {
    this.name = name
    this.message = message
  }
}
